import React from "react";
import get from "lodash/get";
import { Collapse, Table, Button, Icon, InputNumber, Popconfirm } from "antd";

const EventQuestionMetricsContainer = ({
  event,
  choiceIndex,
  form,
  getEventFieldName,
  onAddQuestionMetricRequested,
  onRemoveQuestionMetricRequested,
}) => (
  <Collapse
    defaultActiveKey={
      get(event, `choices[${choiceIndex}].metrics`) ? 1 : undefined
    }
  >
    <Collapse.Panel header="Choice metrics" forceRender={true} key={1}>
      <Table
        size="small"
        pagination={false}
        dataSource={Object.entries(
          get(event, `choices[${choiceIndex}].metrics`, {})
        ).map(([id, value]) => ({ id, value }))}
        rowKey="id"
        footer={() => (
          <Button
            onClick={() => onAddQuestionMetricRequested(event, choiceIndex)}
            size="small"
          >
            <Icon type="plus" />
            Add metric
          </Button>
        )}
      >
        <Table.Column title="Id" dataIndex="id" key="id" />
        <Table.Column
          title="Value"
          dataIndex="value"
          key="value"
          render={(value, record, _index) =>
            form.getFieldDecorator(
              getEventFieldName(
                event,
                `choices[${choiceIndex}].metrics.${record.id}`
              ),
              {
                initialValue: value,
              }
            )(<InputNumber size="small" />)
          }
        />
        <Table.Column
          title="Actions"
          key="actions"
          render={(_text, { id }, _index) => (
            <Popconfirm
              onConfirm={() =>
                onRemoveQuestionMetricRequested(event, choiceIndex, id)
              }
              title="Do you really want to delete this metric?"
              cancelText="No"
              okText="Yes"
            >
              <Button type="danger" size="small">
                <Icon type="delete" />
              </Button>
            </Popconfirm>
          )}
        />
      </Table>
    </Collapse.Panel>
  </Collapse>
);

export default EventQuestionMetricsContainer;
